var Events;
(function (Events) {
    document.addEventListener('ControllerReady', function () {
        let div = document.querySelector('#eventsDiv');
        const config = retrieveConfiguration(document);
        const ServicesEndpoint = `/api/events-filter`;
        const containerDetailsEndpoint = `/api/esb/eventLocator/containerDetail?_format=form`;
        const ServicesEndpointPro = `/api/esb/user/getProfile?_format=form`;
        const $dealsContainer = document.querySelector('.wrapper-services-events');
        const item_per_page = 12;
        const $tipologie = document.querySelector('#tipologie');
        let $cooperatives = null;
        let cooperatives = null;
        const $dates = document.querySelector('#date');
        const $cities = document.querySelector('#cities');
        let containerArray = [];
        const monthNames = [
            'Gennaio',
            'Febbraio',
            'Marzo',
            'Aprile',
            'Maggio',
            'Giugno',
            'Luglio',
            'Agosto',
            'Settembre',
            'Ottobre',
            'Novembre',
            'Dicembre',
        ];
        const dates = tail.select($dates, {
            placeholder: 'Seleziona una data',
            locale: 'it',
        });
        if (document.querySelector('#cooperatives')) {
            $cooperatives = document.querySelector('#cooperatives');
            cooperatives = tail.select($cooperatives, {
                placeholder: 'Seleziona una cooperativa',
                locale: 'it',
            });
        }
        const tips = tail.select($tipologie, {
            placeholder: 'Seleziona una tipologia',
            locale: 'it',
        });
        const cities = tail.select($cities, {
            placeholder: 'Seleziona una città',
            locale: 'it',
        });
        var events_subs_input = document.getElementById('events_subs');
        var events_subs = JSON.parse(events_subs_input.value);
        var card_container = document.getElementById('cards-container');
        var item_showed_counter = document.getElementById('item_showed_counter');
        var carica_altri_button = document.getElementById('carica_altri');
        const queryString = window.location.search;
        if (queryString) {
            const urlParams = new URLSearchParams(queryString);
            if (urlParams.get('token') != null && urlParams.get('coopId') != null && urlParams.get('format') == "app") {
                getProfile(urlParams.get('token'), urlParams.get('coopId'));
            }
        }
        function setAllCookies(token, globalCoopId, responseGetProfile) {
            setCookie('session_token', token);
            setCookie('session_coopId', globalCoopId);
            setCookieInfo(responseGetProfile);
        }
        function setCookieInfo(response) {
            document.cookie =
                'session_info=' +
                    response.payload.profile.coopId +
                    '|' +
                    response.payload.profile.pdv +
                    '|' +
                    response.payload.profile.mail +
                    '|' +
                    response.payload.profile.name +
                    '|' +
                    response.payload.profile.surname +
                    '|' +
                    response.payload.profile.birthdate +
                    '|' +
                    (response.payload.profile.eanCard != null && response.payload.profile.eanCard != '' ? 'Y' : 'N') +
                    '; domain = ' +
                    window.location.hostname +
                    '; path = /;secure;';
        }
        function getProfile(token, globalCoopId) {
            var url = { token: token, coopId: globalCoopId };
            Fetch(ServicesEndpointPro, {
                method: 'POST',
                data: url,
                token: {
                    enable: true,
                },
            })
                .then((response) => {
                if (response.header.result == 'OK') {
                    setAllCookies(token, globalCoopId, response);
                }
            })
                .catch((err) => {
                console.error('Error: ', err);
            });
        }
        document.querySelectorAll('.iscr').forEach((btn) => {
            btn.addEventListener('click', subscription);
        });
        function subscription(evt) {
            var _a;
            const param = evt.target.id;
            const url = evt.target.dataset.urltoredirect;
            const approvato = evt.target.getAttribute('data-attribute');
            let redirectUrl = null;
            const cooperativeName = [];
            if (approvato == 1) {
                (_a = document
                    .querySelector(`[id="${param.split('|')[0]}"]`)) === null || _a === void 0 ? void 0 : _a.querySelectorAll('.cooperative').forEach((cooperativa) => {
                    cooperativeName.push(cooperativa.innerHTML);
                });
                if (getCookie('session_info') == '') {
                    let descr = "L'evento è riservato ai soci di <b>";
                    descr +=
                        'Coop Alleanza 3.0, Coop Amiatina, Coop Liguria, Coop Lombardia, Coop Reno, Novacoop, Unicoop Etruria, Unicoop Firenze';
                    descr += '</b>';
                    showModalUnsub(true, descr, param);
                    return;
                }
                if (getCookie('session_coopId') == '44' ||
                    getCookie('session_coopId') == '17' ||
                    getCookie('session_coopId') == '36' ||
                    (getCookie('session_coopId') == '7' &&
                        (getCookie('session_info').split('|').length < 7 ||
                            getCookie('session_info').split('|')[6] == 'N'))) {
                    let descr = "L'evento è riservato ai soci di <b>";
                    descr +=
                        'Coop Alleanza 3.0, Coop Amiatina, Coop Liguria, Coop Lombardia, Coop Reno, Novacoop, Unicoop Etruria, Unicoop Firenze';
                    descr += '</b>';
                    showModalUnsub(false, descr, param);
                    return;
                }
                if (url) {
                    deleteCookie('event_info');
                    redirectUrl = url;
                }
                else {
                    setCookie('event_info', param);
                    redirectUrl = '/eventi/ringraziamento';
                }
            }
            else {
                if (url) {
                    deleteCookie('event_info');
                    redirectUrl = url;
                }
                else if (getCookie('session_info') == '') {
                    setCookie('event_info', param);
                    redirectUrl = '/auth/login';
                }
                else {
                    setCookie('event_info', param);
                    redirectUrl = '/eventi/ringraziamento';
                }
            }
            if (redirectUrl) {
                dataLayer.push({
                    event: 'registrazione_evento_start',
                    step_registrazione: 'click_partecipa',
                    eventCallback: function () {
                        window.location.href = redirectUrl;
                    },
                    eventTimeout: 500
                });
            }
        }
        function showModalUnsub(bool, description, param) {
            const $body = document.querySelector('body');
            const $modal = document.querySelector('.event-unsubscribe-modal');
            const $btnContinua = $modal === null || $modal === void 0 ? void 0 : $modal.querySelector('.accept'); 
            const $btnAltriEventi = $modal === null || $modal === void 0 ? void 0 : $modal.querySelector('.no-accept'); 
            const $descrizione = $modal === null || $modal === void 0 ? void 0 : $modal.querySelector('#description');
            const $title = $modal === null || $modal === void 0 ? void 0 : $modal.querySelector('.info');
            if (bool) {
                $btnContinua.innerHTML = 'Continua';
                $title.innerHTML = '';
            }
            $descrizione.innerHTML = description;
            $modal === null || $modal === void 0 ? void 0 : $modal.classList.remove('d-none');
            $body === null || $body === void 0 ? void 0 : $body.classList.add('scrollLock');
            $btnContinua === null || $btnContinua === void 0 ? void 0 : $btnContinua.removeEventListener('click', () => { });
            $btnContinua === null || $btnContinua === void 0 ? void 0 : $btnContinua.addEventListener('click', () => {
                $modal === null || $modal === void 0 ? void 0 : $modal.classList.add('d-none');
                $body === null || $body === void 0 ? void 0 : $body.classList.remove('scrollLock');
                if (bool)
                    continuaIscrizione(param);
            });
            $btnAltriEventi === null || $btnAltriEventi === void 0 ? void 0 : $btnAltriEventi.addEventListener('click', () => {
                $modal === null || $modal === void 0 ? void 0 : $modal.classList.add('d-none');
                $body === null || $body === void 0 ? void 0 : $body.classList.remove('scrollLock');
                window.location.href = '/eventi';
            });
        }
        function continuaIscrizione(eventId) {
            setCookie('event_info', eventId);
            window.location.href = '/eventi/ringraziamento';
        }
        function checkFilterOnURL() {
            if ($dates.value != '') {
                dates.trigger('change');
            }
            if ($tipologie.value != '') {
                tips.trigger('change');
            }
            if (document.querySelector('#cooperatives')) {
                if ($cooperatives.value != '') {
                    cooperatives.trigger('change');
                }
            }
            if ($cities.value != '') {
                cities.trigger('change');
            }
        }
        function setCookie(cname, cvalue) {
            document.cookie =
                cname + '=' + encodeURIComponent(cvalue) + ';domain=' + window.location.hostname + ';path=/;secure;';
        }
        function getCookie(cname) {
            let name = cname + '=';
            let decodedCookie = decodeURIComponent(document.cookie);
            let ca = decodedCookie.split(';');
            for (let i = 0; i < ca.length; i++) {
                let c = ca[i];
                while (c.charAt(0) == ' ') {
                    c = c.substring(1);
                }
                if (c.indexOf(name) == 0) {
                    return c.substring(name.length, c.length);
                }
            }
            return '';
        }
        function deleteCookie(name) {
            if (getCookie(name) != '') {
                document.cookie =
                    name +
                        '=' +
                        ';domain=' +
                        window.location.hostname +
                        ';path=/' +
                        ';secure' +
                        ';expires=Thu, 01 Jan 1970 00:00:01 GMT;';
            }
        }
        function retrieveConfiguration($wrapper) {
            let data = {};
            const $form = $wrapper && $wrapper.querySelector('.ep-config');
            if ($form) {
                try {
                    const url = $form.querySelector('[name="url"]').value;
                    const config = $form.querySelector('[name="config"]').value;
                    data = {
                        url: url.replace(/\/$/, ''),
                        config: JSON.parse(config),
                    };
                }
                catch (e) {
                    console.log('Error during retrieval of configuration for current service. %s', e);
                }
            }
            return data;
        }
        if ($dealsContainer) {
            const $loadMore = document.querySelector('[data-load-more]');
            let $carousel = document.querySelector('.train-card');
            const pageCount = 12;
            let config;
            let currPage = 0;
            let filters = new Map();
            function retrieveConfig($wrapper) {
                let data = {};
                const $form = $wrapper && $wrapper.querySelector('.ep-config');
                if ($form) {
                    try {
                        const url = $form.querySelector('[name="url"]').value;
                        const config = $form.querySelector('[name="config"]').value;
                        data = {
                            url: url.replace(/\/$/, ''),
                            config: JSON.parse(config),
                        };
                    }
                    catch (e) {
                        console.log('Error during retrieval of configuration for current service. %s', e);
                    }
                }
                return data;
            }
            function initFilters() {
                var tip_id = $tipologie.dataset.id;
                if (document.querySelector('#cooperatives')) {
                    var coop_id = $cooperatives.dataset.id;
                    toggleFiltersHeight(cooperatives, coop_id);
                }
                var date_id = $dates.dataset.id;
                var cities_id = $cities.dataset.id;
                const data = config || retrieveConfig($dealsContainer);
                config = data;
                toggleFiltersHeight(dates, date_id);
                toggleFiltersHeight(tips, tip_id);
                toggleFiltersHeight(cities, cities_id);
            }
            function toggleFiltersHeight(filter, id) {
                filter.on('change', () => {
                    const values = filter.value();
                    if (values) {
                        filters.set(id, values.join(','));
                    }
                    else {
                        filters.delete(id);
                    }
                    sendrequest();
                });
            }
            function init() {
                carica_altri_button.addEventListener('click', sendOtherRequest);
                document.querySelectorAll('.status-text').forEach(item => {
                    item.addEventListener('click', openModalLegend);
                });
                initFilters();
                checkFilterOnURL();
            }
            function isMobile() {
                return window.innerWidth <= 900;
            }
            function sendrequest() {
                div.setAttribute('data-spinner', 'mask');
                var myJsonFilterString = calculateJsonFromMap(filters);
                var item_showed = document.getElementById('item_showed');
                const tot_cards = document
                    .querySelector('#cards-container')
                    .querySelectorAll('.type-3').length;
                const tot_containers = document
                    .querySelector('#cards-container')
                    .querySelectorAll('.type-3.container-event').length > 0
                    ? document
                        .querySelector('#cards-container')
                        .querySelectorAll('.type-3.container-event').length
                    : 0;
                const tot_events = document.querySelectorAll('.single-event');
                let last_event = '0';
                if (tot_events.length > 0)
                    last_event = document
                        .querySelectorAll('.single-event')[tot_events.length - 1].getAttribute('id');
                Fetch(ServicesEndpoint, {
                    method: 'POST',
                    data: {
                        filters: myJsonFilterString,
                        item_showed: last_event,
                        comtainer_showed: tot_containers,
                        load_more: false,
                    },
                    token: {
                        enable: true,
                    },
                })
                    .then((response) => {
                    let resp = response['data'];
                    if (resp.header.status == 'OK') {
                        var eventi_filtrati = resp.body.events;
                        card_container.innerHTML = '';
                        containerArray = [];
                        var i = 0;
                        for (i = 0; i < eventi_filtrati.length; i++) {
                            if (eventi_filtrati[i].container != null) {
                                createContainerCard(eventi_filtrati[i]);
                            }
                            else {
                                createEventCard(eventi_filtrati[i]);
                            }
                        }
                        $carousel = document.querySelector('.train-card');
                        trigger(document, 'init-train-card', $carousel);
                        var carica_altri_button = document.getElementById('carica_altri');
                        if (resp.body.info.card_showed < item_per_page) {
                            carica_altri_button.setAttribute('disabled', '');
                        }
                        else
                            carica_altri_button.removeAttribute('disabled');
                        item_showed_counter.innerHTML = '' + document.querySelector("#cards-container").querySelectorAll(".slide").length;
                        item_showed.value = '' + document.querySelector("#cards-container").querySelectorAll(".slide").length;
                    }
                    else {
                        console.log('Errore nella chiamata del servizio: ' + ServicesEndpoint);
                    }
                    div.removeAttribute('data-spinner');
                })
                    .catch((err) => {
                    console.error('Error: ', err);
                    div.removeAttribute('data-spinner');
                });
            }
            function createEventCard(element) {
                var _a;
                var dummy = document.querySelector('#card_dummy');
                var filter_card = dummy === null || dummy === void 0 ? void 0 : dummy.cloneNode(true);
                var copertina = null;
                var arrayImage = new Array();
                arrayImage = element.images;
                for (let i = 0; i < arrayImage.length; i++) {
                    if (arrayImage[i]['main'] == 1) {
                        copertina = arrayImage[i];
                        break;
                    }
                }
                filter_card.querySelector('#img_filter_card').src = copertina === null || copertina === void 0 ? void 0 : copertina.image;
                filter_card.querySelector('.title').innerHTML = element.title;
                filter_card.querySelector('.category').innerHTML = generateCategoryString(element.category);
                (_a = filter_card.querySelector('.image')) === null || _a === void 0 ? void 0 : _a.addEventListener('click', function () {
                    window.location.href =
                        '/eventi/' +
                            element.id +
                            '/' +
                            element.title.replace(/[^a-zA-Z0-9\s\-_]/gim, '').replace(/\s/gim, '-');
                });
                if (element.onlyMembers == 0) {
                    filter_card.querySelector('.socio').setAttribute('disabled', '');
                }
                var badgeCssClass = getBadge(element.status.id);
                filter_card.querySelector('.status-badge').innerHTML = element.status.description;
                filter_card.querySelector('.status-badge').classList.add(badgeCssClass);
                filter_card.querySelector('.status-text').addEventListener('click', openModalLegend);
                var parts = element.eventStartDate.split('-');
                var eventDtStart = new Date(parseInt(parts[2], 10), parseInt(parts[1], 10) - 1, parseInt(parts[0], 10));
                var eventDtEnd = null;
                if (element.eventEndDate != null) {
                    parts = element.eventEndDate.split('-');
                    eventDtEnd = new Date(parseInt(parts[2], 10), parseInt(parts[1], 10) - 1, parseInt(parts[0], 10));
                }
                var locale = 'it-it';
                var monthEnd = null;
                var monthStart = eventDtStart.toLocaleString(locale, { month: 'long' });
                if (eventDtEnd != null) {
                    monthEnd = eventDtEnd.toLocaleString(locale, { month: 'long' });
                }
                let str_data = 'Data: <b>';
                if (element.eventEndDate == null) {
                    str_data +=
                        eventDtStart.getDate() +
                            ' ' +
                            monthStart[0].toUpperCase() +
                            monthStart.slice(1);
                }
                else if (element.eventStartDate == element.eventEndDate) {
                    str_data +=
                        eventDtStart.getDate() +
                            ' ' +
                            monthStart[0].toUpperCase() +
                            monthStart.slice(1);
                }
                else {
                    str_data +=
                        eventDtStart.getDate() +
                            ' ' +
                            monthStart[0].toUpperCase() +
                            monthStart.slice(1) +
                            '</b> - <b>' +
                            eventDtEnd.getDate() +
                            ' ' +
                            monthEnd[0].toUpperCase() +
                            monthEnd.slice(1);
                }
                str_data += '</b> Ore: <b>';
                if (element.eventStartHour == element.eventEndHour ||
                    element.eventEndHour == null) {
                    let split = element.eventStartHour.split(':');
                    if (split[1] == '00') {
                        str_data += split[0];
                    }
                    else {
                        str_data += element.eventStartHour;
                    }
                }
                else {
                    let splitStart = element.eventStartHour.split(':');
                    let splitEnd = element.eventEndHour.split(':');
                    if (splitStart[1] != '00' || splitEnd[1] != '00') {
                        str_data += element.eventStartHour + ' - ' + element.eventEndHour;
                    }
                    else {
                        str_data += splitStart[0] + ' - ' + splitEnd[0];
                    }
                }
                str_data += '</b>';
                filter_card.querySelector('.due-date').innerHTML = str_data;
                filter_card.querySelector('.description').innerHTML = element.description;
                filter_card.querySelector('.positionClass').innerHTML =
                    element.places[0].name + 
                        '<br>' +
                        element.places[0].address +
                        ', ' +
                        element.places[0].city +
                        ' ' +
                        (element.places[0].zipcode ? ' ' + element.places[0].zipcode : ''); 
                var register_button = filter_card.querySelector('.registerButton');
                var partecipaButton = filter_card.querySelector('.btn.red.register.iscr');
                if (partecipaButton) {
                    if (element.registration.id != 0) {
                        let strID = element.id +
                            '|' +
                            element.title +
                            '|' +
                            formatData(element.eventStartDate) +
                            '|' +
                            formatData(element.eventEndDate) +
                            '|' +
                            element.places[0].name +
                            '<br>' +
                            element.places[0].address +
                            ', ' +
                            element.places[0].city +
                            ' ' +
                            element.places[0].zipcode;
                        partecipaButton === null || partecipaButton === void 0 ? void 0 : partecipaButton.setAttribute('id', strID);
                        if (element.registration.url != null)
                            partecipaButton === null || partecipaButton === void 0 ? void 0 : partecipaButton.setAttribute('data-urltoredirect', element.registration.url);
                        partecipaButton.addEventListener('click', subscription);
                        if (element.type[0].id == 16)
                            partecipaButton === null || partecipaButton === void 0 ? void 0 : partecipaButton.setAttribute('data-attribute', '1');
                    }
                    else {
                        partecipaButton.style.display = "none";
                    }
                }
                register_button.onclick = function () {
                    window.location.href =
                        '/eventi/' +
                            element.id +
                            '/' +
                            element.title.replace(/[^a-zA-Z0-9\s\-_]/gim, '').replace(/\s/gim, '-');
                };
                if (isSubscribed(element.id)) {
                    partecipaButton.innerHTML = 'Iscritto';
                    partecipaButton.setAttribute('disabled', '');
                    partecipaButton.style.width = '40%';
                    partecipaButton.style.background = '#458C47';
                    partecipaButton.style.color = 'white';
                    partecipaButton.style.borderColor = '#3da616';
                }
                else {
                    if (element.status.id != 1) {
                        partecipaButton.setAttribute('disabled', '');
                    }
                }
                if (element.onlyMembers == 1) {
                    filter_card.querySelector('#bollino-socio').style.display =
                        'inline-block';
                }
                var div_associata = filter_card.querySelector('#coop_associata');
                var temp_a = filter_card.querySelector('.cp-link');
                for (let j = 0; j < element.cooperative.length; j++) {
                    var cooperativa_a = temp_a.cloneNode(true);
                    cooperativa_a.innerHTML = element.cooperative[j].description;
                    var linkToPage = getLink(element.cooperative[j].id);
                    cooperativa_a.setAttribute('href', linkToPage);
                    cooperativa_a.classList.remove('hidden');
                    temp_a.appendChild(cooperativa_a);
                }
                filter_card.classList.remove('dummy');
                filter_card.id = element.id;
                filter_card.classList.add('single-event');
                card_container === null || card_container === void 0 ? void 0 : card_container.appendChild(filter_card);
            }
            function formatData(dataString) {
                if (dataString != null) {
                    const mesi = [
                        'Gennaio',
                        'Febbraio',
                        'Marzo',
                        'Aprile',
                        'Maggio',
                        'Giugno',
                        'Luglio',
                        'Agosto',
                        'Settembre',
                        'Ottobre',
                        'Novembre',
                        'Dicembre',
                    ];
                    const [giorno, meseNumero, anno] = dataString.split('-');
                    const mese = mesi[parseInt(meseNumero) - 1];
                    return `${giorno} ${mese}`;
                }
                return '';
            }
            function createContainerCard(element) {
                if (!containerArray.includes(element.container.id)) {
                    containerArray.push(element.container.id);
                    let container = getContainerDetails(element);
                }
            }
            function generateCategoryString(array) {
                var result = '';
                for (var i = 0; i < array.length; i++) {
                    result += '#' + array[i].description + ' ';
                }
                return result;
            }
            function sendOtherRequest() {
                div.setAttribute('data-spinner', 'mask');
                var myJsonFilterString = calculateJsonFromMap(filters);
                var item_showed = document.getElementById('item_showed');
                const tot_cards = document
                    .querySelector('#cards-container')
                    .querySelectorAll('.type-3').length;
                const tot_containers = document
                    .querySelector('#cards-container')
                    .querySelectorAll('.type-3.container-event')
                    .length > 0
                    ? document
                        .querySelector('#cards-container')
                        .querySelectorAll('.type-3.container-event').length
                    : 0;
                const tot_events = document.querySelectorAll('.single-event');
                let last_event = '0';
                if (tot_events.length > 0)
                    last_event = document
                        .querySelectorAll('.single-event')[tot_events.length - 1].getAttribute('id');
                Fetch(ServicesEndpoint, {
                    method: 'POST',
                    data: {
                        filters: myJsonFilterString,
                        item_showed: last_event,
                        comtainer_showed: tot_containers,
                        load_more: true,
                    },
                    token: {
                        enable: true,
                    },
                })
                    .then((response) => {
                    let resp = response['data'];
                    var eventi_filtrati = resp.body.events;
                    var carica_altri_enabled = resp.body.info.carica_altri_enabled;
                    var i = 0;
                    for (i = 0; i < eventi_filtrati.length; i++) {
                        if (eventi_filtrati[i].container != null) {
                            createContainerCard(eventi_filtrati[i]);
                        }
                        else {
                            createEventCard(eventi_filtrati[i]);
                        }
                    }
                    $carousel = document.querySelector('.train-card');
                    trigger(document, 'init-train-card', $carousel);
                    var total = document.querySelector("#cards-container").querySelectorAll(".slide").length;
                    item_showed_counter.innerHTML = '' + total;
                    item_showed.value = '' + total;
                    if (!carica_altri_enabled) {
                        carica_altri_button.disabled = true;
                    }
                    else {
                        carica_altri_button.disabled = false;
                    }
                })
                    .catch((err) => {
                    console.error('Error: ', err);
                }).finally(() => {
                    div.removeAttribute('data-spinner');
                });
            }
            function getLink(coopId) {
                switch (coopId) {
                    case '1':
                        return 'https://www.coop.it/cooperative/coop-nova/home-nc';
                    case '2':
                        return 'https://www.coop.it/cooperative/coop-liguria/home';
                    case '3':
                        return 'https://www.coop.it/cooperative/coop-lombardia/homepage';
                    case '7':
                        return 'https://www.coopfirenze.it/';
                    case '8':
                        return 'https://www.unicooptirreno.it/';
                    case '9':
                        return 'https://www.coopcentroitalia.it/';
                    case '35':
                        return 'https://www.coopalleanza3-0.it/';
                    default:
                        return '';
                }
            }
            function calculateJsonFromMap(map) {
                let jsonObject = {};
                map.forEach((value, key) => {
                    jsonObject[key] = value;
                });
                return JSON.stringify(jsonObject);
            }
            function isSubscribed(eventId) {
                let idExists = false;
                for (let i = 0; i < events_subs.length; i++) {
                    if (parseInt(events_subs[i].datasetCode) == parseInt(eventId) && events_subs[i].unsubscriptionDate == null) {
                        idExists = true; 
                        break; 
                    }
                }
                return idExists;
            }
            function getContainerDetails(element) {
                var url = {
                    idContainer: element.container.id,
                };
                Fetch(containerDetailsEndpoint, {
                    method: 'POST',
                    data: url,
                    token: {
                        enable: true,
                    },
                })
                    .then((response) => {
                    var _a;
                    if (response.header.result == 'OK') {
                        let container = response.payload.container;
                        if (container != null) {
                            var dummy = document.querySelector('#container_dummy');
                            var filter_card = dummy.cloneNode(true);
                            var copertina = null;
                            var arrayImage = new Array();
                            if (isMobile() && container.imagesMobile.length > 0) {
                                arrayImage = container.imagesMobile;
                            }
                            else {
                                arrayImage = container.images;
                            }
                            for (let i = 0; i < arrayImage.length; i++) {
                                if (arrayImage[i]['main'] == 1) {
                                    copertina = arrayImage[i];
                                    break;
                                }
                            }
                            filter_card.querySelector('#img_filter_card').src = copertina.image;
                            filter_card.querySelector('.title').innerHTML = container.title;
                            filter_card.querySelector('.category').innerHTML = container.tag;
                            (_a = filter_card
                                .querySelector('.image')) === null || _a === void 0 ? void 0 : _a.addEventListener('click', function () {
                                window.location.href =
                                    '/eventi/' +
                                        container.id +
                                        '/' +
                                        container.title
                                            .replace(/[^a-zA-Z0-9\s\-_]/gim, '')
                                            .replace(/\s/gim, '-') +
                                        '?container=true';
                            });
                            var parts = container.startDate.split('-');
                            var eventDtStart = new Date(parseInt(parts[2], 10), parseInt(parts[1], 10) - 1, parseInt(parts[0], 10));
                            var eventDtEnd;
                            if (container.endDate != null) {
                                parts = container.endDate.split('-');
                                eventDtEnd = new Date(parseInt(parts[2], 10), parseInt(parts[1], 10) - 1, parseInt(parts[0], 10));
                            }
                            let str_data = '';
                            let locale = 'it-it';
                            if (eventDtEnd == null || eventDtStart == eventDtEnd) {
                                str_data += formatDateEvents(eventDtStart, eventDtEnd, container.events);
                            }
                            else if (eventDtEnd != null &&
                                eventDtStart.toLocaleString(locale, { month: 'long' }) !=
                                    eventDtEnd.toLocaleString(locale, { month: 'long' })) {
                                str_data += formatDateRange(eventDtStart, eventDtEnd, true);
                            }
                            else {
                                str_data += formatDateRange(eventDtStart, eventDtEnd, false);
                            }
                            filter_card.querySelector('.due-date').innerHTML = str_data;
                            filter_card.querySelector('.description').innerHTML =
                                container.description;
                            var register_button = filter_card.querySelector('.registerButton');
                            register_button.onclick = function () {
                                window.location.href =
                                    '/eventi/' +
                                        container.id +
                                        '/' +
                                        container.title
                                            .replace(/[^a-zA-Z0-9\s\-_]/gim, '')
                                            .replace(/\s/gim, '-') +
                                        '?container=true';
                            };
                            if (isSubscribed(element.id)) {
                                register_button.innerHTML = 'Gestisci Iscrizione';
                            }
                            if (element.onlyMembers == 1) {
                                filter_card.querySelector('#bollino-socio').style.display = 'inline-block';
                            }
                            filter_card.classList.remove('dummy');
                            filter_card.id = container.id;
                            filter_card.classList.add('container-event');
                            card_container === null || card_container === void 0 ? void 0 : card_container.appendChild(filter_card);
                        }
                    }
                    else {
                        return '';
                    }
                })
                    .catch((err) => {
                });
            }
            function formatDateRange(start, end, bool) {
                const startMonth = monthNames[start.getMonth()];
                const endMonth = monthNames[end.getMonth()];
                if (bool) {
                    return `Dal ${start.getDate()} ${startMonth} ${start.getFullYear()} al ${end.getDate()} ${endMonth} ${end.getFullYear()}`;
                }
                else {
                    return `Dal ${start.getDate()} al ${end.getDate()} ${startMonth} ${end.getFullYear()}`;
                }
            }
            function formatDateEvents(start, end, events) {
                if (!start || !events)
                    return '';
                const startDate = new Date(start);
                const endDate = end ? new Date(end) : null;
                const monthNames = [
                    "Gennaio", "Febbraio", "Marzo", "Aprile", "Maggio", "Giugno",
                    "Luglio", "Agosto", "Settembre", "Ottobre", "Novembre", "Dicembre"
                ];
                const getMonthName = (date) => monthNames[date.getMonth()];
                const isSameDay = (d1, d2) => d1.getDate() === d2.getDate() &&
                    d1.getMonth() === d2.getMonth() &&
                    d1.getFullYear() === d2.getFullYear();
                const isDifferentMonth = (d1, d2) => d1.getMonth() !== d2.getMonth() ||
                    d1.getFullYear() !== d2.getFullYear();
                if (endDate && isSameDay(startDate, endDate)) {
                    let orari = '';
                    events.forEach((event, index) => {
                        if (events.length > 2) {
                            orari += event.eventStartHour + (index < events.length - 1 ? ' - ' : '');
                        }
                        else if (events.length === 1) {
                            orari += event.eventStartHour;
                        }
                        else {
                            orari += event.eventStartHour + (index === 0 ? ' e ' : '');
                        }
                    });
                    return `Data: ${startDate.getDate()} ${getMonthName(startDate)} ${startDate.getFullYear()} Ore: ${orari}`;
                }
                if (!endDate) {
                    return `Dal ${startDate.getDate()} ${getMonthName(startDate)} ${startDate.getFullYear()}`;
                }
                if (isDifferentMonth(startDate, endDate)) {
                    return `Dal ${startDate.getDate()} ${getMonthName(startDate)} ${startDate.getFullYear()} al ${endDate.getDate()} ${getMonthName(endDate)} ${endDate.getFullYear()}`;
                }
                return `Dal ${startDate.getDate()} al ${endDate.getDate()} ${getMonthName(endDate)} ${endDate.getFullYear()}`;
            }
            function getBadge(statusId) {
                const statusMap = {
                    1: 'success',
                    2: 'warning',
                    3: 'danger',
                    4: 'danger',
                    5: 'warning',
                    6: 'danger',
                    7: 'danger',
                    8: 'warning' 
                };
                const cssClass = statusMap[statusId] || 'warning';
                return cssClass;
            }
            function openModalLegend() {
                const $body = document.querySelector('body');
                const $modal = document.querySelector('.event-legend-modal');
                $modal === null || $modal === void 0 ? void 0 : $modal.classList.remove('d-none');
                $body === null || $body === void 0 ? void 0 : $body.classList.add('scrollLock');
                var buttonChiudi = $modal === null || $modal === void 0 ? void 0 : $modal.querySelector('.accept');
                if (buttonChiudi != null) {
                    buttonChiudi.addEventListener('click', function () {
                        $modal === null || $modal === void 0 ? void 0 : $modal.classList.add('d-none');
                        $body === null || $body === void 0 ? void 0 : $body.classList.remove('scrollLock');
                    });
                }
            }
            init();
        }
    });
})(Events || (Events = {}));
